import { Component, Input } from '@angular/core';
import { ErrorService, SplittypayError } from 'src/app/core/error.service';
import { Store, StoresService } from 'src/app/core/stores.service';
import { ERROR_STORE_NOT_FOUND } from 'src/app/shared/constants/operationals';

@Component({
  selector: 'app-company-details-store-data',
  templateUrl: './company-details-store-data.component.html',
  styleUrls: ['./company-details-store-data.component.scss'],
})
export class CompanyDetailsStoreDataComponent {
  @Input() company_id?: string | null;
  stores?: Store[];
  is_read_running = true;

  constructor(private stores_service: StoresService, private error_service: ErrorService) {}

  ngOnInit(): void {
    this.stores = [];
    if (this.company_id) this.listStores(this.company_id);
  }

  onRefresh(): void {
    this.stores = [];
    if (this.company_id) this.listStores(this.company_id);
  }

  listStores(company_id?: string): void {
    this.is_read_running = true;

    if (company_id) {
      this.stores_service.listStoresByCompanyID(company_id).subscribe({
        next: response => {
          this.stores = response.data;
          this.is_read_running = false;
        },
        error: error => {
          const processed_error: SplittypayError = this.error_service.preProcessApiError(error);
          if (processed_error.code == ERROR_STORE_NOT_FOUND) {
            this.stores = [];
          } else {
            this.error_service.processApiError(processed_error.code, processed_error.message);
          }
          this.is_read_running = false;
        },
      });
    }
  }
}
